type WindowWithEnv = {
  _env_? : any;
};

const configProvider = (name : string, defaultValue = '') : string => {
  return ((window as WindowWithEnv & typeof globalThis)._env_ || {})[name] || defaultValue;
}

export default configProvider;
